/* eslint-disable lines-between-class-members */

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import React from 'react'

import LabelWrapper from '../LabelWrapper'

class RadioGroupComponent extends React.Component {
  handleClick = (item, index) => {
    const { enableDeselect, onChange, value } = this.props
    if (onChange) {
      if (enableDeselect && item.value === value) {
        onChange()
      } else {
        onChange(item.value, index)
      }
    }
  }
  render() {
    const {
      customCol,
      customMargin,
      customPadding,
      customWidth,
      optionIsDisabled,
      errorText,
      fullWidth,
      helperText,
      id,
      isLabelInline,
      isRequired,
      isToolTip,
      label,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
      name,
      options,
      value,
      onChange,
      disabled,
      ...rest
    } = this.props

    return (
      <LabelWrapper
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
        {...rest}
      >
        <RadioGroup name={name} value={value}>
          {options.map((item, index) => (
            <FormControlLabel
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              key={index}
              value={item.value}
              control={
                <Radio
                  color="primary"
                  // biome-ignore lint/correctness/noUnusedVariables: TODO
                  onClick={event => this.handleClick(item, index)}
                  // biome-ignore lint/complexity/useOptionalChain: TODO
                  disabled={disabled || (optionIsDisabled && optionIsDisabled(item, index))}
                />
              }
              label={item.label}
            />
          ))}
        </RadioGroup>
      </LabelWrapper>
    )
  }
}

RadioGroupComponent.defaultProps = {
  default: '',
  fullWidth: false,
  notWrapper: true,
  withBorder: true,
}

RadioGroupComponent.displayName = 'RadioGroup'
export default RadioGroupComponent
